import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./CancelButton.css";

const { t } = new Translate();

export const CancelButton = ({ forceLeftAlign, onClick, text }) => (
  <button
    className={cx(styles.cancel, { [styles.alignLeft]: forceLeftAlign })}
    onClick={onClick}
    type="button"
  >
    {text}
  </button>
);

CancelButton.propTypes = {
  forceLeftAlign: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

CancelButton.defaultProps = {
  text: t("cancel"),
};

export default CancelButton;
